import ReactTooltip from 'react-tooltip';

export default function TooltipComponent(props: any) {

    return <ReactTooltip type="dark" arrowColor="rgba(0,0,0,0)" />

}